import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptors
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ======================== User QLT Functions ========================

/**
 * Lấy tất cả User QLT
 */
export const fetchAllUsersQLT = async () => {
  try {
    const response = await apiClient.get('/api/authQLT/allUser');
    return response.data || [];
  } catch (error) {
    console.error('Error fetching users QLT:', error);
    throw error.response?.data || { message: 'Failed to fetch users' };
  }
};

/**
 * Xóa User QLT
 */
export const fetchDelUserQLT = async (userId) => {
  try {
    const response = await apiClient.delete(`/api/authQLT/user/${userId}`);
    return { id: userId, ...response.data };
  } catch (error) {
    console.error('Error deleting user QLT:', error);
    throw error.response?.data || { message: 'Failed to delete user' };
  }
};

/**
 * Cập nhật User QLT
 */
export const fetchUpdateUserQLT = async (id, data) => {
  try {
    const response = await apiClient.put(`/api/authQLT/user/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating user QLT:', error);
    throw error.response?.data || { message: 'Failed to update user' };
  }
};

/**
 * Export User QLT ra Excel
 */
export const fetchExportUserQLT = async (letter, startDate, endDate) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/authQLT/export-user?letter=${letter}&startDate=${startDate}&endDate=${endDate}`,
      { method: 'GET' }
    );

    if (!response.ok) throw new Error('Lỗi khi xuất dữ liệu');

    const blob = await response.blob();
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = `users_QLT_${letter}_${startDate}_${endDate}.xlsx`;
    link.click();
    URL.revokeObjectURL(url);

    return { success: true, message: 'Xuất dữ liệu thành công' };
  } catch (error) {
    console.error('Error exporting user QLT:', error);
    throw { message: 'Lỗi khi xuất dữ liệu' };
  }
};

// ======================== Default Export ========================
export default {
  fetchAllUsersQLT,
  fetchDelUserQLT,
  fetchUpdateUserQLT,
  fetchExportUserQLT,
};

